import { isNotFetched } from "@smartdevis/utils/src/async"
import { clientActions } from "../store"
import { mkResolver } from "./resolverUtils"

export const resolveContractorsDirectory = mkResolver(
    s => s.data.contractorsDirectory,
    s => (isNotFetched(s.data.contractorsDirectory) ? [clientActions.fetchContractorsDirectory()] : [])
)
